module.exports = __webpack_public_path__ + "img/img-82.444e4959.png";